// TODO: Consider moving this somwhere else
export const DEFAULT_LANGUAGE = 'en';
